export default __webpack_public_path__ + "e8bb2c24c4bb60085ae8a931279babbb.svg";